import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.93 1 1 5.92 1 12C1 18.08 5.93 23 12 23C18.07 23 23 18.08 23 12C23 5.92 18.07 1 12 1ZM11 6.93C11 6.38 11.45 5.93 12 5.93C12.55 5.93 13 6.38 13 6.93V12.43C13 12.98 12.55 13.43 12 13.43C11.45 13.43 11 12.98 11 12.43V6.93ZM12 17.68C11.31 17.68 10.75 17.12 10.75 16.43C10.75 15.74 11.31 15.18 12 15.18C12.69 15.18 13.25 15.74 13.25 16.43C13.25 17.12 12.69 17.68 12 17.68Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconExclamationmarkCircleFill = forwardRef(Icon);
export default IconExclamationmarkCircleFill;
